module.exports = "<mat-spinner style=\"position:absolute; z-index: 1001\"></mat-spinner>\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/shared/components/spinner/spinner.component.html
// module id = ./src/app/shared/components/spinner/spinner.component.html
// module chunks = main